// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__1VE7k","item":"styles_item__3q1wA","active":"styles_active__25gy8"};